var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75.5 63.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #003851;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -9627.82,
    y1: 11565.85,
    x2: -9627.82,
    y2: 11602.45,
    gradientTransform: "translate(-9581.47 11602.45) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6aa4a2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5da5a2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#49a6a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3aa7a5",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#31a8a5",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ea9a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.07,9.84h0c-4.8-4.8-11.09-7.2-17.38-7.2s-12.58,2.4-17.38,7.2h0c-9.6,9.6-9.6,25.17,0,34.77h0c4.8,4.8,11.09,7.2,17.38,7.2s12.58-2.4,17.38-7.2h0c9.6-9.6,9.6-25.17,0-34.77Zm-1.93,32.84c-4.13,4.13-9.62,6.4-15.45,6.4s-11.33-2.27-15.45-6.4c-4.13-4.13-6.4-9.62-6.4-15.45s2.27-11.33,6.4-15.45c4.13-4.13,9.62-6.4,15.45-6.4s11.33,2.27,15.45,6.4c4.13,4.13,6.4,9.62,6.4,15.45s-2.27,11.33-6.4,15.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m.39,63.33c.6.45,1.48.41,2.01-.12l17.38-17.38c.53-.53.53-1.4,0-1.93h0c-.53-.53-1.4-.53-1.93,0L1.44,60.3s-.01.01-.02.02l-1.36,1.49s-.29,1.06.32,1.52Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.74 0 75.5 .12 43.08 36.61 17.2 36.61 49.74 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e8d0ea92722b1dae131d162800295db3.svg";
export { ForwardRef as ReactComponent };